import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Pluggable } from '@plone/volto/components/manage/Pluggable';

const messages = defineMessages({
  mainView: {
    id: 'skiplink-main-content',
    defaultMessage: 'Skip to main content',
  },
  navigation: {
    id: 'skiplink-navigation',
    defaultMessage: 'Skip to navigation',
  },
  footer: {
    id: 'skiplink-footer',
    defaultMessage: 'Skip to footer',
  },
  navLabel: {
    id: 'Skiplinks',
    defaultMessage: 'Skip links',
  },
});

const SkipLinks = () => {
  const intl = useIntl();

  return (
    <nav
      className="skiplinks-wrapper" 
      aria-label={intl.formatMessage(messages.navLabel)}
    >
      <ul className="list-unstyled">
        <li>
          <a className="skiplink" href="#view">
            {intl.formatMessage(messages.mainView)}
          </a>
        </li>
        <li>
          <a className="skiplink" href="#navigation">
            {intl.formatMessage(messages.navigation)}
          </a>
        </li>
        <li>
          <a className="skiplink" href="#footer">
            {intl.formatMessage(messages.footer)}
          </a>
        </li>
      </ul>
      
      

      <Pluggable name="main.skiplinks" />
    </nav>
  );
};

export default SkipLinks;
